











import { Component, Vue, Watch } from 'vue-property-decorator';
import InquiryForm from '@/components/inquiry/new/Form.vue';

@Component({
  components: {
    'inquiry-form': InquiryForm
  }
})
export default class NewInquiryView extends Vue {}
